<template>
  <b-card>
    <b-row>
      <!-- <b-col
        md="3"
        class="mb-1"
      >
        <b-input-group>
          <b-form-input placeholder="Фильтр..." />
          <b-input-group-append>
            <b-button variant="outline-primary">
              Поиск
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col> -->
      <b-col
        md="9"
        class="mb-1"
      >
        <b-button
          v-ripple.400="'rgba(255, 159, 67, 0.15)'"
          v-b-modal.modal-add
          variant="outline-warning"
        >
          Добавить
        </b-button>
      </b-col>
      <b-col>
        <b-form-input
          id="input-default"
          v-model="searchBrand"
          placeholder="Поиск Бренда"
          @input="onSearchInput"
        />
      </b-col>
    </b-row>
    <app-table
      responsive="sm"
      :items="items"
      :fields="tableColumns"
      :loading="loading"
    >
      <template v-slot:cell(actions)="data">
        <b-button
          v-b-modal.modal-warning-edit
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="warning"
          class="btn-icon mr-1"
          @click="edit(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          variant="gradient-danger"
          class="btn-icon"
          @click="confirmDelete(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
      <template #cell(logo)="data">
        <b-avatar
          v-if="data.item.logo"
          class="mr-1"
          :src="`${IMG_URL}${data.item.logo}`"
        />
      </template>
    </app-table>
    <b-modal
      id="modal-add"
      ok-variant="warning"
      ok-title="Сохранить"
      cancel-title="Закрыть"
      modal-class="modal-warning"
      centered
      title="Добавление"
      @hidden="resetModal"
      @ok="add"
    >
      <validation-observer ref="simpleRules">
        <b-col cols="12">

          <label for="input-default">Название Бренда</label>
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Название"
              rules="required"
            >
              <b-form-input
                id="input-default"
                v-model="brand.name"
                placeholder="Название Бренда"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!--      <label for="brand-img">Лого бренда</label>-->
          <!--      <b-form-file-->
          <!--        id="brand-img"-->
          <!--        placeholder="Choose a file or drop it here..."-->
          <!--        drop-placeholder="Drop file here..."-->
          <!--        multiple-->
          <!--      />--></b-col>
        <b-col cols="12">
          <b-form-group
            label="Описание Бренда"
            label-for="largeInput"
          >
            <validation-provider
              #default="{ errors }"
              name="Описание Бренда"
              rules="required"
            >
              <b-form-input
                id="largeInput"
                v-model="brand.description"
                size="lg"
                placeholder="Описание Бренда"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Slug"
            label-for="largeInput"
          >
            <validation-provider
              #default="{ errors }"
              name="Slug"
              rules="required"
            >
              <b-form-input
                id="slugInput"
                v-model="brand.slug"
                size="lg"
                placeholder="Slug"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </b-col>
        <b-col cols="12">
          <b-form-group>
            <b-form-file
              v-model="brand.file"
              size="lg"
              placeholder="Выберите изображение..."
              drop-placeholder="Slide..."
            />
          </b-form-group>

        </b-col>
        <b-col cols="12">
          <b-form-group>
            <b-form-file
              v-model="brand.banner_image"
              size="lg"
              placeholder="Выберите банер..."
              drop-placeholder="Banner..."
            />
          </b-form-group>

        </b-col>
      </validation-observer>
    </b-modal>

    <b-modal
      id="modal-warning-edit"
      ok-variant="warning"
      ok-title="Сохранить"
      modal-class="modal-warning"
      cancel-title="Закрыть"
      centered
      title="Редактирование"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Название Бренда"
                label-for="largeInput"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Название Бренда"
                  rules="required"
                >
                  <b-form-input
                    id="largeInput"
                    v-model="brand.name"
                    size="lg"
                    placeholder="Название Бренда"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="Описание Бренда"
                label-for="largeInput"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Описание Бренда"
                  rules="required"
                >
                  <b-form-input
                    id="largeInput"
                    v-model="brand.description"
                    size="lg"
                    placeholder="Описание Бренда"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Slug"
                label-for="largeInput"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Slug"
                  rules="required"
                >
                  <b-form-input
                    id="slugInput"
                    v-model="brand.slug"
                    size="lg"
                    placeholder="Slug"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <b-form-file
                  v-model="brand.file"
                  size="lg"
                  placeholder="Выберите изображение..."
                  drop-placeholder="Slide..."
                />
              </b-form-group>

            </b-col>
            <b-col cols="12">
              <b-form-group>
                <b-form-file
                  v-model="brand.banner_image"
                  size="lg"
                  placeholder="Выберите банер..."
                  drop-placeholder="Banner..."
                />
              </b-form-group>

            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
    <b-pagination-nav
      v-if="numberOfPages > 1"
      :value="currentPage"
      :number-of-pages="numberOfPages"
      :link-gen="pageLink"
      :disabled="loading"
      use-router
      hide-goto-end-buttons
    />
  </b-card>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import {
  BAvatar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BRow,
  BFormFile,
  VBModal,
  BPaginationNav,
} from 'bootstrap-vue'
import axios from '@axios'
import { $themeConfig } from '@themeConfig'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppTable from '@/components/AppTable.vue'
import routePagination from '@/mixins/routePagination'
import { codeSeparated } from './Pagination/code'

export default {
  components: {
    BFormFile,
    BAvatar,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BButton,
    AppTable,
    BCard,
    BModal,
    BRow,
    BCol,
    BPaginationNav,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [routePagination],
  data() {
    return {
      IMG_URL: $themeConfig.app.IMG_URL,
      passValue: '',
      username: '',
      required,
      searchBrand: this.$route.query.search || '',
      tableColumns: [
        {
          key: 'id',
          label: '#',
        },
        {
          key: 'name',
          label: 'Название',
        },
        {
          key: 'description',
          label: 'Описание',
        },
        {
          key: 'slug',
          label: 'Slug',
        },
        {
          key: 'logo',
          label: 'Изображения',
        },
        // {
        //   key: 'baner',
        //   label: 'Изображения',
        //   sortable: true,
        // },
        {
          key: 'actions',
          label: 'Действия',
        },
      ],
      brand: {
        id: '',
        name: '',
        slug: '',
        description: '',
        file: '',
        banner_image: '',
      },
      codeSeparated,
      defaultPerPage: 200,
    }
  },
  watch: {
    // Keeps the search field in sync on browser back/forward
    '$route.query.search': function syncSearch(value) {
      if (value !== this.searchBrand.trim()) {
        this.searchBrand = value || ''
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer)
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
                    alert('login successfully')
        }
      })
    },
    filterBrand() {
      this.items = this.items.filter(item => item.name.includes(this.searchBrand))
    },
    // Called by the routePagination mixin
    fetchItems({ page, perPage }) {
      const search = this.$route.query.search || ''
      return axios.get(`${$themeConfig.app.API}v2/admin/brands`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        params: {
          search: search || undefined,
          per_page: perPage,
          page,
        },
      })
        .then(res => ({
          // Also filtered here in case the backend ignores `search`
          items: res.data.data.filter(item => item.name.toLowerCase().includes(search.toLowerCase())),
          total: res.data.total,
          perPage: res.data.per_page,
        }))
    },
    // Search goes to the URL after a pause in typing
    onSearchInput() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.updateFilters({ search: this.searchBrand.trim() }, { replace: true })
      }, 400)
    },
    async add() {
      const myFormData = new FormData()
      myFormData.append('name', this.brand.name)
      myFormData.append('slug', this.brand.slug)
      myFormData.append('description', this.brand.description)
      if (this.brand.file) {
        myFormData.append('logo', `${await this.getBase64(this.brand.file)}`)
      }
      console.log(this.banner_image, 'banner_image')
      if (this.brand.banner_image) {
        myFormData.append('banner_image', `${await this.getBase64(this.brand.banner_image)}`)
      }
      await axios.post(`${$themeConfig.app.API}v2/admin/brands`, myFormData, {
        headers:
            {
              'Content-Type': 'multipart/form-data',
              Accept: 'application/json',
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
      })
        .then(() => {
          this.addStatus = true
          this.loadItems()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Успешно',
              text: 'Запись успешно добавлен',
              icon: 'CheckSquareIcon',
              variant: 'success',
            },
          })
        })
        .catch(e => {
          this.addStatus = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка',
              text: e.message,
              icon: 'CheckSquareIcon',
              variant: 'danger',
            },
          })
        })
    },
    resetModal() {
      this.brand.name = ''
      this.brand.id = ''
      this.brand.slug = ''
      this.brand.description = ''
      this.brand.file = ''
      this.brand.banner_image = ''
    },
    // eslint-disable-next-line no-unused-vars
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      // bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleEdit()
    },
    async handleEdit() {
      const myFormData = new FormData()
      myFormData.append('name', this.brand.name)
      myFormData.append('slug', this.brand.slug)
      myFormData.append('description', this.brand.description)
      myFormData.append('id', this.brand.id)
      if (this.brand.file && typeof this.brand.file !== 'string') {
        myFormData.append('logo', `${await this.getBase64(this.brand.file)}`)
      }
      if (this.brand.banner_image && typeof this.brand.banner_image !== 'string') {
        myFormData.append('banner_image', `${await this.getBase64(this.brand.banner_image)}`)
      } else if (this.brand.banner_image) {
        myFormData.append('banner_image', this.brand.banner_image)
      }
      myFormData.append('_method', 'put')
      // Edit request
      if (this.brand.id !== '') {
        await axios.post(`${$themeConfig.app.API}v2/admin/brands/${this.brand.id}`, myFormData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        })
          .then(() => {
            this.loadItems()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Успешно',
                text: 'Данные были изменены',
                icon: 'CheckSquareIcon',
                variant: 'success',
              },
            })
          })
          .catch(e => {
            console.log(e)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка',
                text: e.message,
                icon: 'CheckSquareIcon',
                variant: 'danger',
              },
            })
          })
      }

      // // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    edit(data) {
      console.log(data)
      this.brand.name = data.name
      this.brand.id = data.id
      this.brand.slug = data.slug
      this.brand.description = data.description
      this.brand.banner_image = data.banner_image
    },
    confirmDelete(data) {
      this.$bvModal
        .msgBoxConfirm('После удаления данные восстановить нельзя будет!', {
          title: 'Вы уверены что хотите удалить?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Удалить',
          cancelTitle: 'Отменить',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            axios.delete(`${$themeConfig.app.API}v2/admin/brands/${data.id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
            })
              .then(() => {
                this.loadItems()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Успешно',
                    text: 'Данные были удалены',
                    icon: 'CheckSquareIcon',
                    variant: 'success',
                  },
                })
              })
              .catch(e => {
                console.log(e)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Ошибка',
                    text: e.message,
                    icon: 'CheckSquareIcon',
                    variant: 'dander',
                  },
                })
              })
          }
        })
    },
    getBase64(file) {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
          resolve(reader.result)
        }
        reader.readAsDataURL(file)
      })
    },
  },
}
</script>
